/**
 * Page initialization and finalization
 * @module app
 */

import 'jquery-unveil';
import 'magnific-popup';

import { hasTouchEvents } from './device';
import MAEvent from './ma-event';
import { setMediumParam } from './medium';
import Navigation from './navigation';
import { thorPushEvent, thorPushPageViewEvent } from './thor';
import { reportWebVitals } from './web-vitals';

// IE11 polyfill for NodeList
// eslint-disable-next-line no-proto
NodeList.prototype.__proto__ = Array.prototype;

/**
 * Launched at very first
 */
export function initialize() {
    // Add specific class to handle the lack of hover on mobile
    if (!hasTouchEvents()) {
        $(document.body).addClass('no-touch');
    }

    // handle blocks clicks, navigate to url to avoid duplicate links in DOM
    $(document).on('click', '[data-navigate-to-url]', function navigateUrlClick(e) {
        const url = $(this).attr('data-navigate-to-url');

        if (!url) {
            return;
        }

        if (e.ctrlKey || e.metaKey) {
            window.open(url, '_blank');
        } else {
            document.location.href = url;
        }
    });

    // handle refresh data on next and back from the
    $(window).on('popstate', e => {
        $(window).trigger(MAEvent.mapPricesNavigationChanged, e.originalEvent.state);
    });

    // add a Math function toRad to convert a value to a radiant
    // eslint-disable-next-line no-extend-native, no-mixed-operators
    if (typeof Number.prototype.toRad === 'undefined') {
        // eslint-disable-next-line no-extend-native, no-mixed-operators
        Number.prototype.toRad = function toRad() {
            return (this * Math.PI) / 180;
        };
    }

    $.extend(true, $.magnificPopup.defaults, {
        tClose: 'Fermer', // Alt text on close button
        tLoading: 'Chargement...', // Text that is displayed during loading. Can contain %curr% and %total% keys
        gallery: {
            tPrev: 'Photo précédente', // Alt text on left arrow
            tNext: 'Photo suivante', // Alt text on right arrow
            tCounter: '%curr% sur %total%', // Markup for "1 of 7" counter
        },
        image: {
            tError: '<a href="%url%">L\'image</a> ne peut être chargée.', // Error message when image could not be loaded
        },
        ajax: {
            tError: '<a href="%url%">Le contenu</a> ne peut être chargé.', // Error message when ajax request failed
        },
    });

    $('img').unveil(0, function unveilImg() {
        $(this).on('load', function onUnveilImgLoad() {
            $(this).css({ width: '', height: '' });
        });
    });

    reportWebVitals();

    // Show b2b topbanner if user is a Pro
    if (
        typeof global.MA_USER !== 'undefined' &&
        global.MA_USER.id &&
        global.MA_USER.type === 'B2B:Agent' &&
        global.MA_USER.segment === 'Unknown/NA'
    ) {
        const topBanner = $('[data-b2b-topbanner]');
        topBanner.removeClass('hide');
    }

    Navigation.initializeMobileNav();
    $('[data-nav-top-level-link]').on('click', () => {
        thorPushEvent('click', {
            link_url: window.location.pathname,
            outbound: true,
            av_zone: 'top|left',
        });
    });

    setMediumParam();

    thorPushPageViewEvent(window.location.pathname);
}

export default {
    initialize,
};
